import React from 'react';
import apiClient from '../../apiClient';

import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import './Imports.scss';
import Button from '@material-ui/core/Button';
import moment from 'moment';
import Spinner from '../Spinner';
import Papa from "papaparse";
import { Table, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";
import { readSpreadsheetFile } from '../../spreadsheet';


class Imports extends React.Component {

 
    state = {
        Results: [],
        data: [],
        headersTicket: [
          { label: "Ticket Number", key: "TicketNumber" },
          { label: "PO Number", key: "PONumber" },
          { label: "Date", key: "Date" },
          { label: "User Name", key: "UserName" },
          { label: "Vendor Name", key: "VendorName" },
          { label: "Customer Name", key: "CustomerName" },
          { label: "Total Ticket Price", key: "TotalTicketPrice" },
        ],

        ReportData: [],
        loading:false,
        TicketDetail:[],
        submitted: false,
      showTranDetail:false,
      showTranEdit:false,
      errorMessage:'',
      action:'edit',
      tranDetail:[],
      fullWidth:true,
      maxWidth:'md',
      maxEditWidth:'lg',
      import:'',
      search:{startDate:null,endDate:null,vendorId:0,customerId:0,ponumber:"",ticketnumber:"",tabindex:0,report:''},
      customerFields:['Customer'],
      vendorFields:['Vendor'],
      inventoryFields:['Item Number','Item Name','Vendor','Item Category','Item Qty','Cost','Target Price'],
      metricUIDFields:['Item Number','Item Name','MetrcUID','Location'],
      apiVendorData:[],
      apiCustomerData:[],
      fullGroupData:[],
      inventoryData:[],
      hasContent:false,
      successMessage:'',
      index:0,
      startDate:null,
      fileType:''
       
    }

    handleFileUpload = (event) => {
      const file = event.target.files[0];
  
      if (!file) return;
  
      const fileName = file.name;
      const fileExtension = fileName.split(".").pop().toLowerCase();
  
      if (fileExtension === "csv") {
        this.setState({fileType:fileExtension});
        this.processCSV(file);
      } else if (fileExtension === "xls" || fileExtension === "xlsx") {
        this.setState({fileType:fileExtension});
        this.processExcel(file);
      } else {
        alert("Invalid file type! Please upload a CSV or Excel file.");
        return;
      }
    };

    validateMetricUIDFileHeaders(firstRow) {
      if (!firstRow) return false;
      const keys = Object.keys(firstRow).map((k) => k.replace(/^\uFEFF/, '').trim());
      if (keys.length < 2 || keys.length > 4) return false;

      const hasCombined = keys.some(
        (k) => k === 'Item Number + Item Name' || k === 'Item Number +Item Name'
      );
      const hasItemNumber = keys.some((k) =>
        ['Item Number', 'ItemNumber', 'itemnumber'].includes(k)
      );
      const hasItemName = keys.some((k) =>
        ['Item Name', 'ItemName', 'itemname'].includes(k)
      );
      const hasSeparate = hasItemNumber && hasItemName;
      const hasMetric = keys.some((k) =>
        ['MetrcUID', 'MatrcUID', 'MetricUID', 'MatricUID', 'Metric UID', 'Matric UID', 'Metrc UID', 'Matrc UID'].includes(k)
      );

      if (!hasMetric || (!hasCombined && !hasSeparate)) return false;

      const allowed = new Set([
        'Item Number + Item Name',
        'Item Number +Item Name',
        'Item Number',
        'ItemNumber',
        'itemnumber',
        'Item Name',
        'ItemName',
        'itemname',
        'MetrcUID',
        'MatrcUID',
        'MetricUID',
        'MatricUID',
        'Metric UID',
        'Matric UID',
        'Metrc UID',
        'Matrc UID',
        'Location',
        'Location Name',
        'location',
      ]);
      return keys.every((k) => allowed.has(k));
    }

    normalizeImportRows(rows) {
      return (rows || []).map((row) => {
        const out = {};
        Object.entries(row || {}).forEach(([key, value]) => {
          const norm = String(key).replace(/^\uFEFF/, '').trim();
          if (norm) out[norm] = value;
        });
        return out;
      });
    }

    formatMetricUidImportIssueLine(issue) {
      if (issue && typeof issue.message === 'string' && issue.message.trim() !== '') {
        return issue.message.trim();
      }
      const label =
        (issue && issue.label) ||
        (issue && issue.itemNumber) ||
        (issue && issue.itemName) ||
        'Unknown';
      if (issue && issue.type === 'itemNotFound') {
        return `Item ${label} doesn't exist.`;
      }
      if (issue && issue.type === 'itemInactive') {
        return `Item ${label} is not active and cannot be updated.`;
      }
      const locationName =
        issue && issue.locationName != null ? String(issue.locationName).trim() : '';
      if (locationName) {
        return `Item ${label} exists but not in location "${locationName}".`;
      }
      return `Item ${label} exists but not in this location.`;
    }

    formatMetricUidImportIssueDetails(importResult) {
      const issues = Array.isArray(importResult.issues) ? importResult.issues : [];
      if (!issues.length) {
        return '';
      }
      const lines = issues.map((issue) => this.formatMetricUidImportIssueLine(issue));
      const failedCount = Number(importResult.failedCount) || lines.length;
      if (lines.length === 1) {
        return `${failedCount} item(s) could not be imported:\n${lines[0]}`;
      }
      return `${failedCount} item(s) could not be imported:\n${lines.join('\n')}`;
    }

    formatMetricUidImportErrorMessage(importResult) {
      if (!importResult || typeof importResult !== 'object') {
        return 'MetrcUID import failed.';
      }
      if (typeof importResult.message === 'string' && importResult.message.trim() !== '') {
        return importResult.message.trim();
      }
      if (typeof importResult.error === 'string' && importResult.error.trim() !== '') {
        return importResult.error.trim();
      }
      const issueDetails = this.formatMetricUidImportIssueDetails(importResult);
      if (issueDetails) {
        return issueDetails;
      }
      return 'MetrcUID import failed.';
    }

    handleMetricUidImportResult(importResult) {
      const importSelected = this.state.import;
      const updatedCount = Number(importResult.updatedCount) || 0;
      const failedCount =
        Number(importResult.failedCount) ||
        (Array.isArray(importResult.issues) ? importResult.issues.length : 0);
      const isPartial = updatedCount > 0 && failedCount > 0;
      const isFullSuccess = updatedCount > 0 && failedCount === 0;

      if (isFullSuccess) {
        this.setState({
          import: importSelected,
          data: [],
          loading: false,
          successMessage:
            importResult.message || `MetrcUID updated for ${updatedCount} item(s).`,
          errorMessage: null,
        });
        setTimeout(() => {
          this.setState({ successMessage: null });
        }, 5000);
        return;
      }

      if (isPartial) {
        this.setState({
          import: importSelected,
          data: [],
          loading: false,
          successMessage: `MetrcUID updated for ${updatedCount} item(s).`,
          errorMessage: this.formatMetricUidImportIssueDetails(importResult),
        });
        setTimeout(() => {
          this.setState({ successMessage: null, errorMessage: null });
        }, 30000);
        return;
      }

      const resultMessage = this.formatMetricUidImportErrorMessage(importResult);
      this.setState({
        import: importSelected,
        loading: false,
        errorMessage: resultMessage,
        successMessage: null,
      });
      setTimeout(() => {
        this.setState({ errorMessage: null });
      }, 30000);
    }

    showErrorMsg(){
      var importSelected = this.state.import;
     
      var errorMessage = 'Selected file does not contain the required data. Please select related file.';
      this.setState({import:''});
      this.setState({data:[]});
      this.setState({import:importSelected});
      setTimeout(() => {
        this.setState({ errorMessage:errorMessage });
       
      }, 1000);
       
      setTimeout(() => {
        this.setState({ errorMessage: null });
       
       }, 3000);

    }
  
    processCSV = (file) => {
      Papa.parse(file, {
        complete: (result) => {

          var counter = 0;
                  if(this.state.import == 'Customer')
                  {
                    Object.keys(result.data[0]).forEach((key) => {
                      if(this.state.customerFields[counter] != key)
                      {
                        
                        this.showErrorMsg();

                        return true;
                      }
                      counter = counter+1;
                    });
                  }
                  else if(this.state.import == 'Vendor')
                  {
                    Object.keys(result.data[0]).forEach((key) => {
                      if(this.state.vendorFields[counter] != key)
                      {
                       
                        this.showErrorMsg();
                        return true;
                      }
                      counter = counter+1;
                    });
          
                  }
                  else if(this.state.import == 'Inventory')
                    {
                      Object.keys(result.data[0]).forEach((key) => {
                        if(this.state.inventoryFields[counter] != key)
                        {
                         
                          this.showErrorMsg();
                          return true;
                        }
                        counter = counter+1;
                      });
                      
                    }
                  else if(this.state.import == 'MetricUID')
                  {
                    if (!this.validateMetricUIDFileHeaders(result.data[0])) {
                      this.showErrorMsg();
                    }
                  }
                 

          this.setState({data: this.normalizeImportRows(result.data)});
        },
        header: true,
        skipEmptyLines: true,
      });
    };

    
  
    processExcel = (file) => {
      readSpreadsheetFile(file)
      .then((parsedData) => {
        var counter = 0;
                if(this.state.import == 'Customer')
                {
                  Object.keys(parsedData[0]).forEach((key) => {
                    if(this.state.customerFields[counter] != key)
                    {
                     
                      
                        this.showErrorMsg();
                      return true;
                    }
                    counter++;
                  });
                }
                else if(this.state.import == 'Vendor')
                {
                  Object.keys(parsedData[0]).forEach((key) => {
                    if(this.state.vendorFields[counter] != key)
                    {
                      this.showErrorMsg();
                      return true;
                    }
                    counter = counter+1;
                  });
                 
                }
                else if(this.state.import == 'Inventory')
                  {
                    Object.keys(parsedData[0]).forEach((key) => {
                      if(this.state.inventoryFields[counter] != key)
                      {
                        this.showErrorMsg();
                        return true;
                      }
                      counter = counter+1;
                    });
                  
                  }
                else if(this.state.import == 'MetricUID')
                {
                  if (!this.validateMetricUIDFileHeaders(parsedData[0])) {
                    this.showErrorMsg();
                  }
                }
        this.setState({data: this.normalizeImportRows(parsedData)});
      })
      .catch((error) => {
        const message = error && error.message
          ? error.message
          : 'The selected spreadsheet could not be read.';
        this.setState({ data: [], errorMessage: message, successMessage: null });
        setTimeout(() => this.setState({ errorMessage: null }), 6000);
      });
    };

   
    
    handleLinkClick = (items) => {
      this.setState({ showTranDetail: true });
      this.setState({tranDetail: items});
    };

    handleLinkEditClick = (items,action) => {
      
      this.setState({ action: action });
      this.setState({ showTranEdit: true });
      this.setState({tranDetail: items});
    };



  handleSubmit = async () => {
    this.setState({ loading: true }); 
          let user = JSON.parse(sessionStorage.getItem('user'));
          let accessToken = user.accessToken;
          var endPoint = '';

          if(this.state.import == 'Vendor' )
            {
              endPoint = `/api/post/vendors`;
            }
          else if(this.state.import == 'Customer' )
            {
              endPoint = `/api/post/customers`;
            }
            else if(this.state.import == 'MetricUID' )
            {
              endPoint = `/api/post/import-metricuid`;
              apiClient.post(endPoint, this.state.data, {
                headers: {"Content-Type": "application/json","Authorization" : `Bearer ${accessToken}`},
                validateStatus: (status) => status >= 200 && status < 500,
              })
              .then((res) => {
                this.handleMetricUidImportResult(res && res.data ? res.data : {});
              })
              .catch((err) => {
                const apiData = err.response && err.response.data;
                if (apiData && typeof apiData === 'object') {
                  this.handleMetricUidImportResult(apiData);
                  return;
                }
                this.handleMetricUidImportResult({
                  ok: false,
                  cancelled: true,
                  error: 'MetrcUID import failed. Please check your connection and try again.',
                });
              });
              return;
            }
            else if(this.state.import == 'Inventory' )
              {
                endPoint = `/api/post/inventories`;

                const groups = {};
                for (const item of this.state.data) {
                  const key = item['Vendor'].trim();
                  groups[key] = groups[key] || [];
                  groups[key].push(item);
                }
                var newItemsGroup = Object.values(groups);
                const vendors = [];
                for (const groupVendor of newItemsGroup) {
                  var vendorName = groupVendor[0]['Vendor'];
                  vendors.push({Vendor:vendorName.trim()});
                }

                apiClient.post('/api/post/vendors',  JSON.stringify(vendors) , {  headers: {"Content-Type": "application/json","Authorization" : `Bearer ${accessToken}`} })
                .then(async res => {
                  setTimeout(() => {
                    apiClient.post(endPoint,  this.state.data , { headers: {"Authorization" : `Bearer ${accessToken}`} })
                    .then(async res => {
                      const importResult = res && res.data ? res.data : {};
                      const hasPartialFailure =
                        importResult.partial === true ||
                        Number(importResult.failedCount) > 0;
                      const partialMsg =
                        (importResult && importResult.message) ||
                        'There are currently no item numbers available within this category. Pls review limits for this Item Category. All other items were saved.';
                      if (hasPartialFailure) {
                        this.setState({ errorMessage: partialMsg });
                        setTimeout(() => {
                          this.setState({ errorMessage: null });
                        }, 10000);
                      }
                      setTimeout(() => {
                       apiClient.get('/api/get/vendor', { headers: {"Authorization" : `Bearer ${accessToken}`} })
                        .then(async vendors => {

                              apiClient.get('/api/get/item', { headers: {"Authorization" : `Bearer ${accessToken}`} })
                            .then(async itemList => {
      var counter = 0;
                                for (const groupVendor of newItemsGroup) {

                                
                                    counter++;
                                var vendorName = groupVendor[0]['Vendor'];
                                var vendorId = vendors.data.filter(x=>x.VendorName.trim() == vendorName.trim())[0].VendorId;
                                var data ={};
                                data.vendorId = vendorId;
                                data.date = moment().format('MM-DD-YYYY');
                                data.action = 'CheckIn';
                                data.ticketNumber = null;
                                data.customerName = vendorName;
                                data.userId = user.userId;
                                data.reason = '';
                                data.oldItemData = [];
                                var itemData = [];
                                for (const item of groupVendor) {
                                  var itemId = itemList.data.filter(x=>x.ItemName?.toLowerCase().trim() == item['Item Name']?.toLowerCase().trim())[0]?.ItemId;
                                  if (!itemId) {
                                    continue;
                                  }
                                      itemData.push({
                                        "Itemnumber": item['Item Number'],
                                        "itemid": itemId,
                                        "checkinqty": item['Item Qty'],
                                        "itemname": item['Item Name'],
                                        "targetprice": (item['Target Price'] == undefined || item['Target Price'] == null || item['Target Price'] == '') ? 0 : item['Target Price'].toString().trim(),
                                        "priperunit": (item['Cost'] == undefined || item['Cost'] == null || item['Cost'] == '') ? 0 : item['Cost'].toString().trim(),
                                        "totpri": ((item['Cost'] == undefined || item['Cost'] == null || item['Cost'] == '') ? 0 : item['Cost'].toString().trim()) * ((item['Item Qty'] == undefined || item['Item Qty'] == null || item['Item Qty'] == '') ? 0 : item['Item Qty'].toString().trim()),
                                      });
                                  }
                                  data.itemData = itemData;
                                  if (itemData.length === 0) {
                                    if (newItemsGroup.length == counter) {
                                      var importSelected = this.state.import;
                                      this.setState({import:''});
                                      this.setState({data:[]});
                                      this.setState({import:importSelected});
                                      this.setState({
                                        successMessage:
                                          hasPartialFailure
                                            ? 'Data imported with some skipped items.'
                                            : (importResult && importResult.message) ||
                                          'Data have been successfully imported!, The records which already, have been discarded.'
                                      });
                                      setTimeout(() => {
                                        this.setState({ successMessage: null });
                                      }, 3000);
                                      this.setState({ loading: false }); 
                                    }
                                    continue;
                                  }
                                  await apiClient.post(`/api/post/transactionCheckIn`, JSON.stringify({data}), { headers: {"Content-Type": "application/json","Authorization" : `Bearer ${accessToken}`} }) .then(async res => {
                                    if (newItemsGroup.length == counter) {
                                    var importSelected = this.state.import;
                                    this.setState({import:''});
                                    this.setState({data:[]});
                                    this.setState({import:importSelected});
                                    this.setState({
                                      successMessage:
                                        hasPartialFailure
                                          ? 'Data imported with some skipped items.'
                                          : (importResult && importResult.message) ||
                                        'Data have been successfully imported!, The records which already, have been discarded.'
                                    });
                                    setTimeout(() => {
                                      this.setState({ successMessage: null });
                                    }, 3000);
                                    this.setState({ loading: false }); 
                                  }
                                  });
                                
                                            
                                          
                                
                              }
                            });
                      });
                    }, 3000);
                     
                    }).catch((err) => {
                      const apiErr = err.response && err.response.data && err.response.data.error;
                      const msg =
                        typeof apiErr === 'string' && apiErr.trim() !== ''
                          ? apiErr
                          : 'Inventory import failed.';
                      this.setState({ loading: false, errorMessage: msg });
                      setTimeout(() => {
                        this.setState({ errorMessage: null });
                      }, 8000);
                    })
                  }, 3000);
                  
                });
                
              }

              if(this.state.import == 'Vendor'  ||   this.state.import == 'Customer' )
              {
                apiClient.post(endPoint,  JSON.stringify(this.state.data) , { headers: {"Content-Type": "application/json","Authorization" : `Bearer ${accessToken}`} })
                .then(res => {
                  var importSelected = this.state.import;
                  this.setState({import:''});
                  this.setState({data:[]});
                  this.setState({import:importSelected});
                  this.setState({ successMessage: 'Data have been successfully imported!, The records which already, have been discarded.' });
                  setTimeout(() => {
                    this.setState({ successMessage: null });
                    this.setState({ loading: false }); 
                  }, 3000);
                })
              }

            
    }



    handleSetSearchDate = (e => {
     
      this.setState({data: []});
      this.setState({import: e['target']['value']});
     
    });
   
    handleSetSearchData = (event) => {
      this.state.search[event.target.name] = event.target.value;
      this.state.search["tabindex"] = this.state.index;
      this.setState({
        search: this.state.search,
       });
    };

    componentDidMount() {
      let user = JSON.parse(sessionStorage.getItem('user'));
      sessionStorage.setItem('TranSearch', null);
     
  if(user.permissions.filter(x=>x.PermissionName == 'Imports' && x.PermissionAllowed == 1).length == 0)
         {
            const { history } = this.props;
            history.push('/home');
         }

     
    };
    a11yProps(index) {
      return {
        id: `scrollable-auto-tab-${index}`,
        'aria-controls': `scrollable-auto-tabpanel-${index}`,
      };
    }
      

    onTabClicked = (event, newValue) => {
      const { history } = this.props;
      this.setState({ index: newValue });
      this.state.search["startDate"] = null;
      this.state.search["endDate"] = null;
      this.state.search["vendorId"] = 0;
      this.state.search["customerId"] = 0;
      this.state.search["ponumber"] = "";
      this.state.search["ticketnumber"] = "";
      this.state.search["tabindex"] = newValue;
      
      this.setState({
        search:  this.state.search
       });
      history.push('/vendor-details');
         setTimeout(() => {
          history.push('/transactions');
        }, 1);
      
     
  }

   
    
    handleMoreSearch = () => {

      const { history } = this.props;
      history.push('/vendor-details');
         setTimeout(() => {
          history.push('/transactions');
        }, 1); 
      
      


    };


  

    
      
    
  
    
  render() {
    return (
      
      <div style={{ maxWidth: '100%' }} className="Report">
       <h2>Imports</h2>
         <form   style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr' }}>
        
          <div  style={{ marginLeft: '200px' }}>
              <FormControl  margin="normal">
                <InputLabel id="select-label">Select Import</InputLabel>
                <Select
                      label="Import"
                      name="import" 
                      value={this.state.import}
                     onChange={(e) => this.handleSetSearchDate(e)}
                      margin="normal"
                      displayEmpty
                      inputProps={{ 'aria-label': 'Without label' }} >
                    <MenuItem value="Inventory">  Inventory</MenuItem>
                    <MenuItem value="MetricUID">  MetrcUID</MenuItem>
                    <MenuItem value="Customer">  Customer</MenuItem>
                    <MenuItem value="Vendor">  Vendor</MenuItem>
                </Select>  
              </FormControl>
          </div>
          <div  >
            {(this.state.import == 'Customer')  && 
                  (
                    <table>
                    <tr><th>CSV Column requirement for Customer</th></tr> 
                    <tr><td>
                         <br/>  Customer
                         </td>
                     </tr>
                         
                    </table>
                  )}

{(this.state.import == 'Vendor')  && 
                  (
                    <table>
                    <tr><th>CSV Column requirement for Vendor</th></tr>
                    <tr><td>
                        <br/>   Vendor
                        </td>
                    </tr>
                   </table>
                  )}

{(this.state.import == 'Inventory')  && 
                  (
                    <table>
                    <tr> <th>CSV Column requirement for Inventory</th></tr>
                    <tr> <td>
                        <br/>  Item Number <br/>
                            Item Name <br/>
                            Vendor <br/>
                            Item Category <br/>
                            Item Qty <br/>
                            Cost <br/>
                            Target Price <br/>
                           
                        </td>
                    </tr>
                   </table>
                  )}

{(this.state.import == 'MetricUID')  && 
                  (
                    <table>
                    <tr> <th>CSV Column requirement for MetrcUID</th></tr>
                    <tr> <td>
                        <br/>  Option A: Item Number + Item Name (one column, e.g. 10000 Item Name) <br/>
                            Option B: Item Number and Item Name (separate columns) <br/>
                            MetrcUID <br/>
                            Location (optional — name like Room1, numeric id, or leave blank for default) <br/>
                            Only active, non-archived items can be updated. <br/>
                        </td>
                    </tr>
                   </table>
                  )}
        
        
       
          </div>
          <br/>
           
            {(this.state.import != '')  && 
                  (
                    <div  style={{ marginLeft: '200px' ,marginTop:'50px',marginBottom:'50px'}}>
                    <input type="file" accept=".csv,.xls,.xlsx" onChange={this.handleFileUpload} />
                           
                    </div>
                    
                  )}



                <br/>
                <br/>
                <div>&nbsp;</div>
               
     <div>
                
    
     </div>

         </form>
         {(this.state.data.length > 0 )  && 
                  (
                    <div style={{ maxHeight: '250px' ,overflowY:'auto'}}>
                    <Table 
                      
                      size="small"
                      aria-label="a dense table"
                      > 
                    <TableHead> 
                      <TableRow > 
                      {this.state.data.length > 0 &&
                        Object.keys(this.state.data[0]).map((key) => <TableCell  key={key}>{key}</TableCell>)}
                     
                      </TableRow> 
                    </TableHead> 
                    <TableBody> 
                    {this.state.data.map((row, index) => (
                      <TableRow key={index}>
                        {Object.values(row).map((value, i) => (
                          <TableCell key={i}>{value}</TableCell>
                        ))}
                      </TableRow>
                    ))}
                    </TableBody> 
                    </Table> 
                </div>
                  )
                }

         <br></br> 

         {(this.state.data.length > 0 )  && 
                  (
                    <div style={{ marginLeft: '50px' ,marginTop:'50px',marginBottom:'50px'}}>
          
            
          <Button
                       color="primary"
                       style= {{ width: '250px' , textAlign:'left'}}
                       variant="contained"
                       onClick={() => this.handleSubmit()}
                       disabled={this.submitted}
                   >
                    
               Import Data
            
                   </Button>
   
        
               </div>
                  )}

       <br></br> 

      
       <br></br> 
         
        
        
        <br/>
        <div style={{textAlign:'right', paddingBottom: '3px'}}>
          
        </div>

      
   


{this.state.loading ? <Spinner /> :""}

{this.state.errorMessage && (
        <div style={{ backgroundColor: '#FF7F7F', color: '#fff', padding: '10px', marginTop: '10px', whiteSpace: 'pre-line' }}>
          {this.state.errorMessage}
        </div>
      )}

{this.state.successMessage && (
        <div style={{ backgroundColor: '#28a745', color: '#fff', padding: '10px', marginTop: '10px' }}>
          {this.state.successMessage}
        </div>
      )}
        
      </div>
      
    )
  }
}
export default Imports;
